import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import styles from '../../realty-filter.module.css';

type RealtyFilterCheckboxProps = {
  item: {
    id: number;
    name: string;
  };
  isSelected: (id: number) => boolean;
  handleFilterUpdate: (itemId: number) => void;
  className?: string;
  copyClassName?: string;
  disabled?: boolean;
  filterKey: 'is_new' | 'number_of_rooms' | 'offer_type';
  idPrefix: string;
};

export const RealtyFilterCheckbox = ({
  item,
  isSelected,
  handleFilterUpdate,
  className,
  copyClassName,
  disabled = false,
  filterKey,
  idPrefix,
}: RealtyFilterCheckboxProps) => {
  const checked = isSelected(item.id);
  const checkboxId = `${idPrefix}-${item.id}`;

  return (
    <label
      className={styles.checkboxLabel}
      data-disabled={disabled ? 'true' : undefined}
      htmlFor={checkboxId}
    >
      <CheckboxPrimitive.Root
        id={checkboxId}
        checked={checked}
        data-eli-part="realty-filter-checkbox"
        data-filter-key={filterKey}
        data-filter-value={item.id}
        disabled={disabled}
        onCheckedChange={() => handleFilterUpdate(item.id)}
        className={cn(styles.checkbox, className)}
      >
        <CheckboxPrimitive.Indicator className={styles.checkboxIndicator}>
          <svg
            aria-hidden="true"
            className={styles.checkboxIcon}
            focusable="false"
            viewBox="0 0 24 24"
          >
            <path
              d="M18.3096 7.18955C18.5909 7.47084 18.7488 7.8523 18.7488 8.25005C18.7488 8.64779 18.5909 9.02925 18.3096 9.31055L10.8096 16.8105C10.5284 17.0918 10.1469 17.2497 9.74915 17.2497C9.3514 17.2497 8.96994 17.0918 8.68865 16.8105L5.68865 13.8105C5.41541 13.5276 5.26422 13.1487 5.26763 12.7554C5.27105 12.3621 5.42881 11.9859 5.70692 11.7078C5.98503 11.4297 6.36125 11.272 6.75454 11.2685C7.14784 11.2651 7.52674 11.4163 7.80965 11.6895L9.74915 13.629L16.1886 7.18955C16.4699 6.90834 16.8514 6.75037 17.2491 6.75037C17.6469 6.75037 18.0284 6.90834 18.3096 7.18955Z"
              fill="currentColor"
            />
          </svg>
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <span className={copyClassName}>{item.name}</span>
    </label>
  );
};
